/* eslint-disable */
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
require('moment/locale/pt-br');
var Datetime = require('react-datetime');

import * as mensagemActions from './actions/mensagemActions'
import * as classificacaoActions from './actions/classificacaoActions'
import * as tipoPessoaActions from './actions/tipoPessoaActions'
import * as grupoTratamentoUFClassificacaoActions from './actions/grupoTratamentoUFClassificacaoActions'
import * as navegacaoActions from './actions/navegacaoActions'
import * as enderecoActions from './actions/enderecoActions'
import * as anexosActions from './actions/anexosActions'
import * as ufActions from './actions/ufActions'
import SelectClassificacoes from './common/SelectClassificacoes'
import Captcha from './Captcha'
import SelectUF from './common/SelectUF';
import SelectTipoPessoa from './common/SelectTipoPessoa';
import DenunciaForm from './DenunciaForm'
import * as sasActions from './actions/sasActions'
import Helpers from './util/Helpers'
import * as SacUF from './util/SacUF'
import ConfigD from './util/ConfigD';
import './css/loginForm.css'
import './css/sliderDiv.css'
import './css/imgSelected.css'
import './css/cadastrarProtocolo.css'
import $ from 'jquery';
import InputMask from 'react-input-mask';
import Dropzone from 'react-dropzone'
import Alert from 'react-s-alert';
import './css/ReactSelect2.css'

//Entrada UPP (rota /UPP e canal 'upp' nas rotas de cadastrarProtocolo)
var CANAL_ENTRADA_UPP = 136; //Site Lei Geral
var ID_CLASSIFICACAO_SUGESTAO_UPP = 4; //Sugestão (fixa no UPP)
var SIGLA_UF_UPP = 'NA'; //Sebrae Nacional


class CadastarProtocoloForm extends React.Component {

    constructor(props, context) {
        super(props, context);
        //debugger;
        this.state = {
            showError:'',
            cpf: '',
            cep:'',
            nome:'',
            email:'',
            aceitoTermo: false,
            autorizarDadosDenunciado: false,
            endTelefone: '',
            endCelular: '',
            classificacoesSelecinadas: null,
            tipoPessoaSelecinada:null,
            valueUFusuario: 0,
            valueUFusuarioOrigem:0,
            clienteIdentificado:true,
            errCep: '',
            errCpf:'*Campo obrigatório',
            errDtNascimento: '*Campo obrigatório',
            endBairro:'',
            endEndereco:'',
            endCidade:'',
            dtNascimento:'',
            accept: '.pdf, .jpg, .png, .mp4, .avi, .mp3',
            files: [],
            dropzoneActive: false,
            txtDenunciaDocumento: '',
            txtDenunciaEvidencia: '', 
            txtDenunciaLideranca: '',
            txtDenunciaMeioConhecimento: '',
            txtDenunciaQuandoOnde: '',
            txtDenunciaTempo: '',
            txtDenunciaTestemunha: '',
            txtDenunciaValor: '',
            txtDenunciaAmeaca:'',
            captchaValue:'',
            captchaUserValue:'',
            captchaValido:false,
            idx:1,
            stateShowErro:false,
            objNavegacao:{} ,
            errEmail: '*Campo obrigatório',
            apresentarIdenfificadoDenuncia: true
            
        };
        this.cadastrar = this.cadastrar.bind(this);
        this.setCpf = this.setCpf.bind(this);
        this.setNome = this.setNome.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.setTelefene = this.setTelefene.bind(this);
        this.setCelular = this.setCelular.bind(this);
        this.setDtNascimento = this.setDtNascimento.bind(this);
        this.setCep = this.setCep.bind(this);
        this.setEndereco = this.setEndereco.bind(this);
        this.setCidade = this.setCidade.bind(this);
        this.setBairro = this.setBairro.bind(this);
        this.onChangeClassificar = this.onChangeClassificar.bind(this);
        this.onChangeUF = this.onChangeUF.bind(this);
        this.ativarAnonimo = this.ativarAnonimo.bind(this);
        this.ativarIdentificado = this.ativarIdentificado.bind(this);
        this.consultaCep = this.consultaCep.bind(this);
        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.anexar = this.anexar.bind(this);
        this.refreshCaptcha = this.refreshCaptcha.bind(this);
        this.setCaptchaValue = this.setCaptchaValue.bind(this);
        this.setCaptchaUserValue = this.setCaptchaUserValue.bind(this);
        this.captchaValido = this.captchaValido.bind(this);
        this.redirecionarPaginaSucesso = this.redirecionarPaginaSucesso.bind(this);
        this.applyMimeTypes = this.applyMimeTypes.bind(this);
        this.removerAnexo = this.removerAnexo.bind(this);
        this.onChangeUFOrigem = this.onChangeUFOrigem.bind(this);
        this.pesquisarCpfSAS = this.pesquisarCpfSAS.bind(this);
        this.onChangetxtDenunciaDocumento = this.onChangetxtDenunciaDocumento.bind(this);
        this.onChangetxtDenunciaEvidencia = this.onChangetxtDenunciaEvidencia.bind(this);
        this.onChangetxtDenunciaLideranca = this.onChangetxtDenunciaLideranca.bind(this);
        this.onChangetxtDenunciaMeioConhecimento = this.onChangetxtDenunciaMeioConhecimento.bind(this);
        this.onChangetxtDenunciaQuandoOnde = this.onChangetxtDenunciaQuandoOnde.bind(this);
        this.onChangetxtDenunciaTempo = this.onChangetxtDenunciaTempo.bind(this);
        this.onChangetxtDenunciaTestemunha = this.onChangetxtDenunciaTestemunha.bind(this);
        this.onChangetxtDenunciaValor = this.onChangetxtDenunciaValor.bind(this);
        this.onChangetxtDenunciaAmeaca = this.onChangetxtDenunciaAmeaca.bind(this);
        this.getMeiosConhecimentoDenunciaSelecionada = this.getMeiosConhecimentoDenunciaSelecionada.bind(this);
        this.validaCpfDtNascimento = this.validaCpfDtNascimento.bind(this);
        this.onChangeTipoPessoa = this.onChangeTipoPessoa.bind(this);
        this.hasClass = this.hasClass.bind(this);
        this.showError = this.showError.bind(this);
        
    }

    aceitoTermo=()=>{
        //console.log('object', $(this.refs.ckbAceitar).is(':checked'))
        var aceito = $(this.refs.ckbAceitar).is(':checked');
        this.setState({aceitoTermo:aceito});
        
    }


    getMeiosConhecimentoDenunciaSelecionada(val){
        this.setState({meioConhecimentoDenuniaSelecioanda: val})
        //this.showError(e, err);
    }
    onChangetxtDenunciaDocumento(e, err) {
        this.setState({ txtDenunciaDocumento: e});
        this.showError(e, err);
    }

    onChangetxtDenunciaEvidencia(e, err) {
        this.setState({ txtDenunciaEvidencia: e });
        //this.showError(e, err);
    }

    onChangetxtDenunciaLideranca(e, err) {
        this.setState({ txtDenunciaLideranca: e });
        this.showError(e, err);
    }

    onChangetxtDenunciaMeioConhecimento(e, err) {
        this.setState({ txtDenunciaMeioConhecimento: e });
        this.showError(e, err);
    }

    onChangetxtDenunciaQuandoOnde(e, err) {
        this.setState({ txtDenunciaQuandoOnde: e });
        this.showError(e, err);
    }

    showError(e, err){
        if($.isEmptyObject(e)){
            $(err).show();
        }
        else{
            $(err).hide();
        }

    }

    onChangetxtDenunciaTempo(e, err) {
        this.setState({ txtDenunciaTempo: e });
        this.showError(e, err);
    }

    onChangetxtDenunciaTestemunha(e, err) {
        this.setState({ txtDenunciaTestemunha: e });
        this.showError(e, err);
    }

    onChangetxtDenunciaValor(e) {
        this.setState({ txtDenunciaValor: e });
    }

    onChangetxtDenunciaAmeaca(e, err) {
        this.setState({ txtDenunciaAmeaca: e });
        this.showError(e, err);
    }


    refreshCaptcha(){
        var i = this.state.idx+1;
        this.setState({idx:i});
    }

    captchaValido(){
        //debugger
        if(this.state.captchaValue !== '' && this.state.captchaUserValue !== ''){
            if (this.state.captchaValue.toLowerCase() === this.state.captchaUserValue.toLowerCase()) {
                return true;
            }
        }
        else{
            return false;
        }
    }

    setCaptchaValue(text){
        //debugger
        this.setState({
            captchaValue: text
        })
    }

    setCaptchaUserValue(val) {
        this.setState({
            captchaUserValue: val
        })
    }
    
    validaCpfDtNascimento(){
        //debugger
        var validadtNascimento = Helpers.CheckDate($('#txtDtNascimento').val());
        if (validadtNascimento) {
            $("#errDtNascimento").hide();
        }
        else {
            //debugger
            if ($('#txtDtNascimento').val().indexOf('_') >= 0 || $('#txtDtNascimento').val() === '') {
                document.getElementById("errDtNascimento").innerHTML = "* Campo obrigatório";
            }
            else {
                document.getElementById("errDtNascimento").innerHTML = "* Data inválida";
            }
            $("#errDtNascimento").show();
        }

        var validacpf = Helpers.ValidaCPF($('#txtCpf').val());
        if (validacpf) {
            $("#errCpf").hide();
        }
        else {
            //debugger
            if ($('#txtCpf').val().indexOf('_') >= 0 || $('#txtCpf').val() === '') {
                document.getElementById("errCpf").innerHTML = "* Campo obrigatório";
            } else {
                document.getElementById("errCpf").innerHTML = "* CPF inválido";
            }
            $("#errCpf").show();
        }
        //debugger
        if (validacpf && validadtNascimento) {
            return true
        }else{
            return false;
        }
    }

    pesquisarCpfSAS(){
        //debugger
        if (this.validaCpfDtNascimento()){
            
            var parametroConsulta = {
                cpfcnpj: $('#txtCpf').val(),
                dataNascimento: $('#txtDtNascimento').val()
            };
            //debugger
            //$("#errCpf").hide();
            //$("#errDtNascimento").hide();
            //this.setState({ pesquisando: true });
            this.props.actionsSAS.ConsultaSAS(parametroConsulta).then(
                () => {
                    //this.setState({ pesquisando: false });
                }).catch(error => {
                    //debugger
                    if (error === null) {
                        this.setState({ errCpf: '*Cpf não encontrado' });
                        $("#errCpf").show();
                    } else {
                        Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                            position: 'top-right',
                            effect: 'slide',
                            offset: 172,
                            timeout: 5000
                        });

                    }
            });
            return true;
        }
        else{
            return false
        }
        this.ativarIdentificado();
    }

    removerAnexo(idx) {
        //debugger;
        
        var filesTemp = this.state.files;
        filesTemp.splice(idx,1);
        this.setState({
            files: filesTemp
        });
    }
    
    onDragEnter() {
        this.setState({
            dropzoneActive: true
        });
    }

    onDragLeave() {
        this.setState({
            dropzoneActive: false
        });
    }

    onDropRejected = () => {
    }

    onDrop(files) {
        //debugger;
        var filesTemp = this.state.files;

        files.map((f, index) => {
            filesTemp.push(f);
        })
        this.setState({
            files: filesTemp,
            dropzoneActive: false
        });
        //console.log('files', filesTemp);
    }

    applyMimeTypes(event) {
        this.setState({
            accept: event.target.value
        });
    }

    onChangeTipoPessoa(obj){
        this.setState({ tipoPessoaSelecinada: obj });
        //debugger
        if (obj === null || obj === "") {
            $(this.refs.errorTipoPessoa).show();
        } else {
            $(this.refs.errorTipoPessoa).hide();
        }

    }
    onChangeClassificar(obj) {
        //console.log(`obj`, obj)
        this.setState({ classificacoesSelecinadas: obj });
        if (obj === null || obj === "") {
            $(this.refs.errorClassificacao).show();
            $("#gbIdentificacao").hide();
        } else {
            $("#gbIdentificacao").show();
            if(obj === "11" || obj === "5" || obj === "14"){
                $(".imgAnonimo").hide();
                this.ativarIdentificado();
            }else{
                $(".imgAnonimo").show();
            }
            $(this.refs.errorClassificacao).hide();
        }

    }
     hasClass(element, className) {
         return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
     }

    ativarIdentificado(e){
        //debugger
        var selecionado = this.hasClass(document.getElementById('imgIdentificado'), 'selected' );
        if(!selecionado)
            $('.imgIdentificado').toggleClass('selected');
        $('.imgAnonimo').removeClass('selected');
        $('#apresentarDadosPessoais').show();
        this.setState({clienteIdentificado:true});

    }
    ativarAnonimo(e) {
        var selecionado = this.hasClass(document.getElementById('imgAnonimo'), 'selected' );
        if(!selecionado)
            $('.imgAnonimo').toggleClass('selected');
        $('.imgIdentificado').removeClass('selected');
        $('#apresentarDadosPessoais').hide();
        this.setState({ clienteIdentificado: false });
    }

    consultaCep() {
        if (this.refs.txtCep.value !== '') {
            var data = { cep: this.refs.txtCep.value}
            $(this.refs.errCep).hide();
            this.props.actionEndereco.consultaCEP(data).catch(error => {
                if (error === null) {
                    this.setState({errCep: '*Cep inválido'});
                    $(this.refs.errCep).show();
                } else {
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-right',
                        effect: 'slide',
                        offset: 172,
                        timeout: 5000
                    });

                }
            });;
        }
    }

    //UPP: entrada pela rota /UPP ou pelo canal 'upp' das rotas de cadastrarProtocolo
    isUPP(){
        return !$.isEmptyObject(this.props.params.canal) && this.props.params.canal.toLowerCase() === 'upp';
    }

    //UPP força a UF de origem em Sebrae Nacional, qualquer que seja a UF da URL
    obterSiglaUFParam(){
        return this.isUPP() ? SIGLA_UF_UPP : this.props.params.uf;
    }

    //SAC por UF: a UF de origem vem da URL (select travado) ou do select (idUF, procurado em listaUF)
    isSacIndisponivel(idUF, listaUF){
        var sigla = this.obterSiglaUFParam() || SacUF.siglaDaUF(listaUF, idUF);
        return SacUF.sacIndisponivel(this.props.params.grupo, sigla);
    }

    obterClassificacoesPorGrupoTratamentoUF(uf){
        //SAC por UF: UF bloqueada não consulta as naturezas (a falha da consulta mandaria o cidadão ao Fale Conosco)
        if (this.isSacIndisponivel(uf, this.props.uf)) return;
        //debugger
        var grupoOuvidoria = 1;
        var grupoSac = 3;
        if (!$.isEmptyObject(uf) && this.props.params.grupo) {
            var idUF = parseInt(uf);
            var parametros = {
                idGrupoTratamento: this.props.params.grupo.toLowerCase() === 'sac' ? grupoSac : grupoOuvidoria,
                idUF: idUF
            }
            //debugger;
            this.props.actionsGrupoTratamentoUFClassificacao.ObterGrupoTratamentoUFClassificacaoPorGrupoUF(parametros)
                .catch(error => {
                    //debugger
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-right',
                        effect: 'slide',
                        offset: 172,
                        timeout: 5000
                    });

                });
            }
    }

    onChangeUFOrigem(uf) {
        //debugger
        this.obterClassificacoesPorGrupoTratamentoUF(uf)

        this.setState({ valueUFusuarioOrigem: uf });
        if (uf!==''){
            $(this.refs.errUFusuarioOrigem).hide();
        }    


    }

        onChangeUF(uf) {
        //debugger;
            this.setState({ valueUFusuario: uf });

    }

    setDtNascimento(e) {
        this.setState({
            dtNascimento: e.target.value
        })
    }
    setNome(e) {
        this.setState({
            nome: e.target.value
        })
    }
    setEmail(e) {
        this.setState({
            email: e.target.value
        })
        if (!Helpers.validateEmail(e.target.value)) {
            this.setState({errEmail:'*E-mail inválido'})
            $(this.refs.errEmail).show();
            
        }else{
            $(this.refs.errEmail).hide();
            this.setState({errEmail:''});
        }
    }
    setTelefene(e) {
        this.setState({
            endTelefone: e.target.value
        })
    }

    setCelular(e) {
        this.setState({
            endCelular: e.target.value
        })
    }
    setCpf(e) {
        this.setState({
            cpf: e.target.value
        })
    }
    setCep(e) {
        this.setState({
            cep: e.target.value
        })
    }
    setEndereco(e) {
        this.setState({
            endEndereco: e.target.value
        })
    }
    setCidade(e) {
        this.setState({
            endCidade: e.target.value
        })
    }
    setBairro(e) {
        this.setState({
            endBairro: e.target.value
        })
    }

    setBairro(e) {
        this.setState({
            endBairro: e.target.value
        })
    }

    validaForm() {
        //debugger;
        var aceitoTermo = $(this.refs.ckbAceitar).is(':checked');
        var valido = true;
        $(this.refs.errCaptcha).hide();
        $(this.refs.errEmail).hide();
        $(this.refs.errAceitoTermo).hide();

        //debugger
        if(!aceitoTermo){
            $(this.refs.errAceitoTermo).show();
            valido = false;
        }
        var nome = this.refs.txtNome.value;
        var email = this.refs.txtEmail.value;
        var mensagem = this.refs.txtMensagem.value;
       

        //validar somente se for cliente identificado
        if(this.state.clienteIdentificado){
            if (nome === '') {
                $(this.refs.errNome).show();
                valido = false;
            }
            if (email === '') {
                this.setState({errEmail:'*Campo obrigatório'})
                $(this.refs.errEmail).show();
                valido = false;
            }
            else if (!Helpers.validateEmail(email)) {
                this.setState({errEmail:'*E-mail inválido'})
                $(this.refs.errEmail).show();
                valido = false;
            }
            if (!this.validaCpfDtNascimento()) {
                valido = false;
            }
            if (this.state.tipoPessoaSelecinada === null || this.state.tipoPessoaSelecinada === '') {

                $(this.refs.errorTipoPessoa).show();
                valido = false;
            }
        }
        if (mensagem === '') {
            $(this.refs.errMensagem).show();
            valido = false;
        }

        if(!$.isEmptyObject(this.props.params.natureza) && this.props.params.natureza === 'denuncia'){
            // if($.isEmptyObject(this.state.meioConhecimentoDenuniaSelecioanda)){
            //     valido = false;
            // }
            if($.isEmptyObject(this.state.txtDenunciaDocumento)){
                valido = false;
            }
            if($.isEmptyObject(this.state.txtDenunciaQuandoOnde)){
                valido = false;
            }
            if($.isEmptyObject(this.state.txtDenunciaDocumento)){
                valido = false;
            }
            
            // if($.isEmptyObject(this.state.txtDenunciaEvidencia)){
            //     valido = false;
            // }
            if($.isEmptyObject(this.state.txtDenunciaLideranca)){
                valido = false;
            }
            // if($.isEmptyObject(this.state.txtDenunciaMeioConhecimento)){
            //     valido = false;
            // }
            if($.isEmptyObject(this.state.txtDenunciaTempo)){
                valido = false;
            }
            if($.isEmptyObject(this.state.txtDenunciaTestemunha)){
                valido = false;
            }
            if($.isEmptyObject(this.state.txtDenunciaAmeaca)){
                valido = false;
            }
            if($.isEmptyObject(this.state.txtDenunciaQuandoOnde)){
                valido = false;
            }
        }


        //debugger
        if ((this.state.classificacoesSelecinadas === null || this.state.classificacoesSelecinadas === '') && this.props.params.natureza !== "denuncia") {

            $(this.refs.errorClassificacao).show();
            valido = false;
        }


        //debugger
        if (this.state.valueUFusuarioOrigem === 0 || this.state.valueUFusuarioOrigem === '') {
            $(this.refs.errUFusuarioOrigem).show();
            valido = false;
        }
        if(!this.captchaValido()){
            this.setState({showError:true});
            return false;
        }
        else{
            this.setState({showError:false});
        }
        return valido;
    }



    cadastrar(event){
        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }
        //SAC por UF: UF bloqueada não envia (defesa: o botão fica oculto, mas a regra não depende disso)
        if (this.isSacIndisponivel(this.state.valueUFusuarioOrigem, this.props.uf)) return;
        //debugger
        if (this.validaForm()) {
            var relato = this.refs.txtMensagem.value;
            if(this.state.clienteIdentificado){
                //console.log('validou')
                var nome = this.refs.txtNome.value;
                var email = this.refs.txtEmail.value;
                var cpf = this.refs.txtCpf.value;
                var telefone = this.refs.txtTelefone.value;
                var celular = this.refs.txtCelular.value;
                var cep = this.refs.txtCep.value;
                var bairro = this.refs.txtBairro.value;
                var cidade = this.refs.txtCidade.value;
                var endereco = this.refs.txtEndereco.value;

                var cidadaoUsuarioVO = {
                    mCPFCNPJ: cpf,
                    mNome : nome,
                    mBairro : bairro,
                    mCEP: cep,
                    mCidade: cidade,
                    mEmail: email,
                    mEndereco: endereco,
                    mUF:{ mIdUF: parseInt(this.state.valueUFusuario) },
                    mTelefone: telefone,
                    mCelular: celular
                }
            }

            //Portal = 1
            //Email = 2
            //Carta = 3
            //Rede social = 4
            //Presencial = 5
            //Intranet = 6
            //Telefone = 7
            //Totem = 8            
            //Site Lei Geral (UPP) = 136
            
            var canal = 1;
            if (!$.isEmptyObject(this.props.params.canal) && this.props.params.canal.toLowerCase() === 'intranet'){
                canal = 6;
            } else if (!$.isEmptyObject(this.props.params.canal) && this.props.params.canal.toLowerCase() === 'totem') {
                 canal = 8;
             } else if (this.isUPP()) {
                 canal = CANAL_ENTRADA_UPP;
             }

             var mDenuncia={}
             if (this.props.params.natureza && this.props.params.natureza.toLowerCase() === 'denuncia') {
                mDenuncia = {
                    mAmeaca: this.state.txtDenunciaAmeaca,
                    mDocumento: this.state.txtDenunciaDocumento,
                    mEvidencia: this.state.txtDenunciaEvidencia,
                    mLideranca: this.state.txtDenunciaLideranca,
                    mQuandoOnde: this.state.txtDenunciaQuandoOnde,
                    mTestemunha: this.state.txtDenunciaTestemunha,
                    mValor: this.state.txtDenunciaValor,
                    mTempoConhecimento: this.state.txtDenunciaTempo,
                    mMeioConhecimento: this.state.meioConhecimentoDenuniaSelecioanda
                }
            }else{
                mDenuncia=null;
            }

            //debugger

             var mensagemVO = {                

                mClassificacaoCidadaoUsuario: {mIdClassificacao: !this.state.classificacoesSelecinadas ? 1 : parseInt(this.state.classificacoesSelecinadas)},
                
                mFormaEnvioResposta: this.state.clienteIdentificado ? 1 : 0,
                mTipoRecebimento: { mIdCanalEntrada: canal },
                mUFAbertura: {
                    mIdUF: parseInt(this.state.valueUFusuarioOrigem)
                },
                mTextoCidadao: relato,
                mPrioridadeAtendimento: 1,
                mTipoPessoa: { mIdTipoPessoa: this.state.clienteIdentificado? this.state.tipoPessoaSelecinada :3 },
                mCidadaoInterno: (canal === 6 || canal === 8)? true: false,
                mDenuncia: mDenuncia,
                mIdGrupoTratamentoCadastro: !$.isEmptyObject(this.props.params) && this.props.params.grupo && this.props.params.grupo.toLowerCase() === 'sac' ? 3 : 1,
                mAceitaUsoDados:$(this.refs.ckbAceitar).is(':checked'),
                mClienteAutorizaDadosDenunciado:$(this.refs.ckbAutorizarDadosDenunciado).is(':checked'),
                //se for denuncia, objeto será diferente de null
                
            }
            //debugger
            
            var data = {
                cidadaoUsuarioVO,
                mensagemVO
            }


            //console.log('data - ', data);
            //debugger;            

            var browser = Helpers.getBrowser();
            //console.log('versão - name / version ' + browser.name + ' / ' + browser.version);

            if( browser.name !== 'IE'){
                Helpers.apresentarSpinner('Cadastrando a manifestação');
                this.props.actions.Cadastrar(data).then(()=>
                Helpers.removerSpinner()).catch(error => {
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-right',
                        effect: 'slide',
                        offset: 172,
                        timeout: 5000
                    });
                });;

            }
            else{
                this.props.actions.Cadastrar(data).catch(error => {
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-right',
                        effect: 'slide',
                        offset: 172,
                        timeout: 5000
                    });
            });;

            }

        }
    }

    anexar(mensagem) {
        //debugger
        if (this.state.files.length > 0) {
            Helpers.apresentarSpinner('Anexando arquivo');
            for (let index = 0; index < this.state.files.length; index++) {
                const element = this.state.files[index];
                Helpers.apresentarTxt2(element.name);
                var visivel = "1";
                this.props.actionsAnexos.anexar(
                    mensagem.dado.mAtendimento.mIdAtendimento,
                    mensagem.dado.mHistoricos[(mensagem.dado.mHistoricos.length-1)].mIdHistoricoMensagem, 
                    element,
                    visivel
                ).catch(error => {
                    Helpers.removerSpinner();
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-right',
                        effect: 'slide',
                        offset: 172,
                        timeout: 5000
                    });
                });;
            }
            this.redirecionarPaginaSucesso()
        }
        else{
            this.redirecionarPaginaSucesso()
        }

    }

    redirecionarPaginaSucesso(){
        Helpers.removerSpinner();
        this.context.router.push(ConfigD.getServerBase() + '/protocoloCadastrado');
    }
    componentDidMount() {
        //debugger;
        //debugger;
        
        var objNavegacao = {
          natureza: !$.isEmptyObject(this.props.params) && this.props.params.natureza ? this.props.params.natureza : 'geral',
          uf: !$.isEmptyObject(this.props.params) && this.obterSiglaUFParam() ? this.obterSiglaUFParam():'',
          canal: !$.isEmptyObject(this.props.params) && this.props.params.canal ? this.props.params.canal : 'portal',
          grupoTratamento: !$.isEmptyObject(this.props.params) && this.props.params.grupo ? this.props.params.grupo : 'ouvidoria'
        }

        if ($.isEmptyObject(this.props.navegacao) || this.isUPP()) {
          this.props.actionsNavegacao.ArmazenaNavegacao(objNavegacao)
          //console.log('objNavegacao - cadastrar', objNavegacao)
        }
        
        this.props.actionsClassificacao.ListarClassificacao()
            .catch(error => {
                Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                    position: 'top-right',
                    effect: 'slide',
                    offset: 172,
                    timeout: 5000
                });
            });
            var data = {visivel:true};
            this.props.actionsTipoPessoa.ListarTipoPessoa(data)
            .catch(error => {
                Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                    position: 'top-right',
                    effect: 'slide',
                    offset: 172,
                    timeout: 5000
                });
            });
            
        this.props.actionsUF.listarUF()
            .catch(error => {
                Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                    position: 'top-right',
                    effect: 'slide',
                    offset: 172,
                    timeout: 5000
                });
            });
        //debugger;
        //this.props.actionCliente.validarCliente(null);
        $('.alert-danger', $('#login-form')).hide();


    }
    
    componentWillReceiveProps(nextProps) {
        
        
        var siglaUFParam = this.obterSiglaUFParam();
        //debugger;
         if (!$.isEmptyObject(nextProps.mensagem) && this.props.mensagem !== nextProps.mensagem) {
             //console.log('mensagem cadastrada --> ', nextProps.mensagem)
             this.anexar(nextProps.mensagem);
         }
        if (!$.isEmptyObject(nextProps.endereco) && this.props.endereco !== nextProps.endereco) {
            //debugger
            this.setState({ 
                endBairro: nextProps.endereco.dado.mBairro.mBairro,
                endEndereco: nextProps.endereco.dado.mLogradouro.mLogradouro + ' ' + nextProps.endereco.dado.mComplemento,
                endCidade: nextProps.endereco.dado.mCidade.mCidade,
                valueUFusuario: nextProps.endereco.dado.mUF.mIdUF.toString()
            })
            
        }

        if (!$.isEmptyObject(nextProps.uf) && this.props.uf !== nextProps.uf) {
            //debugger
            if (siglaUFParam) {
                for (var i = 0; i < nextProps.uf.dado.length; i++) {
                    if (siglaUFParam.toLowerCase() === nextProps.uf.dado[i].mSigla.toLowerCase()){
                        //debugger
                        this.setState({ valueUFusuarioOrigem: nextProps.uf.dado[i].mIdUF.toString()})

                        break;
                    }
                }
            }
        }

        //  METODO PARA OBTER AS CLASSIFICAÇÕES DE ACORDO COM O GRUPO DE TRATAMENTO
        //SAC por UF: UF da URL bloqueada não consulta as naturezas
        if (this.props.params.grupo && siglaUFParam && !$.isEmptyObject(nextProps.uf) && !SacUF.sacIndisponivel(this.props.params.grupo, siglaUFParam)){
            if ($.isEmptyObject(nextProps.grupoClassificacoes)&& this.props.params.natureza!=='denuncia') {
                var grupoOuvidoria = 1;
                var grupoSac = 3;
                var idUF = 0;
                for (var i = 0; i < nextProps.uf.dado.length; i++) {
                    if (siglaUFParam.toLowerCase() === nextProps.uf.dado[i].mSigla.toLowerCase()) {
                        //debugger
                        idUF= nextProps.uf.dado[i].mIdUF.toString();
                        break;
                    }
                }
                var parametros = {
                    idGrupoTratamento: this.props.params.grupo.toLowerCase() === 'sac'? grupoSac : grupoOuvidoria,
                    idUF: idUF
                }
                this.props.actionsGrupoTratamentoUFClassificacao.ObterGrupoTratamentoUFClassificacaoPorGrupoUF(parametros)
                     .catch (error => {
                         Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                            position: 'top-right',
                            effect: 'slide',
                            offset: 172,
                            timeout: 5000
                        });
                    
                });
            }
        }


        if (this.props.params.natureza && !$.isEmptyObject(nextProps.classificacoes) && this.props.classificacoes !== nextProps.classificacoes) {
            if (this.props.params.natureza) {
                var natureza = this.props.params.natureza.toLowerCase() === 'denuncia' ? 'Denúncia' : this.props.params.natureza;
                
                
                for (var i = 0; i < nextProps.classificacoes.dado.length; i++) {
                    if (natureza.toLowerCase() === nextProps.classificacoes.dado[i].mDescricao.toLowerCase()) {
                        //debugger
                        this.setState({ classificacoesSelecinadas: nextProps.classificacoes.dado[i].mIdClassificacao.toString() })
                    }
                }
            }
        }


        //UPP: fixa a natureza Sugestão quando as classificações chegam (o select fica desabilitado no render)
        if (this.isUPP() && !$.isEmptyObject(nextProps.classificacoes) && this.props.classificacoes !== nextProps.classificacoes) {
            this.setState({ classificacoesSelecinadas: ID_CLASSIFICACAO_SUGESTAO_UPP.toString() })
        }


        if (!$.isEmptyObject(nextProps.sas) && this.props.sas !== nextProps.sas) {
            // $("#errCpf").hide();
            // $("#errDtNascimento").hide();
            this.setState({ 
                nome: nextProps.sas.dado.NomeRazaoSocial,
                email: nextProps.sas.dado.Email,
                endBairro: nextProps.sas.dado.EnderecoBairro!== null ? nextProps.sas.dado.EnderecoBairro:'',
                endEndereco:  nextProps.sas.dado.Endereco!== null ? nextProps.sas.dado.Endereco + ' ' + nextProps.sas.dado.EnderecoBairro!== null ? nextProps.sas.dado.EnderecoBairro:'':'' ,
                endCidade: nextProps.sas.dado.EnderecoCidade,
                cep: nextProps.sas.dado.CEP !== null && nextProps.sas.dado.CEP !== "0" ? nextProps.sas.dado.CEP :'' ,
                endTelefone: nextProps.sas.dado.TelResidencial !== null ? nextProps.sas.dado.TelResidencial :'' , 
                endCelular: nextProps.sas.dado.TelCelular !== null ? nextProps.sas.dado.TelCelular :'' 

             })
        }

        // if(!$.isEmptyObject(nextProps.classificacoesSelecinadas) && (nextProps.classificacoesSelecinadas === "11" || nextProps.classificacoesSelecinadas === "5")){
        //     $(".imgAnonimo").hide();
        //     this.ativarIdentificado();
        // }else{
        //     $(".imgAnonimo").show();
        // }
        

    }

    render() {
        //console.log('servicos', this.props.servicos);
        //debugger
         if($.isEmptyObject(this.props.classificacoes)){
           return <div/>
         }
        if ($.isEmptyObject(this.props.uf)) {
            return <div />
        }
        //console.log('this.props.servicoCalculado ' , this.state.servicoSelecionado)
        const { accept, files, dropzoneActive } = this.state;
        const overlayStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            padding: '2.7em 0',
            background: 'rgba(0,0,0,0.5)',
            textAlign: 'center',
            color: '#fff'
        };


        var lista = (
            <ul>
                {
                    files.map((f, index) => {
                        //debugger;
                        return <li key={index} >{f.name} - {f.size} bytes <i className="fa fa-times-circle excluir"  onClick={()=>this.removerAnexo(index)}></i></li> 
                    })
                }
            </ul>
        );
        var autorizoDenuncia = '';
        var formDenuncia = '';
        var dropzoneDenuncia = '';
        var dropZoneGeral = '';
        var txtMensagem = '';
        var txtMensagemDenuncia = '';
        var classificacoes = [];
        //se for denúncia deverá apresentar campo de anexar e formulário de denúncia abaixo dos dados do usuário
        //console.log('this.props.params.natureza', this.props.params.natureza)
        if(!$.isEmptyObject(this.props.params.natureza) && this.props.params.natureza === 'denuncia' ){
            if( this.state.clienteIdentificado ){
                autorizoDenuncia = 
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <input type="checkbox" name="ckbAutorizarDadosDenunciado" ref='ckbAutorizarDadosDenunciado' id='ckbAutorizarDadosDenunciado' className="input-icon"/> Autorizo apresentar meu nome ao <strong>DENUNCIADO</strong>
                                    <span ref='errAutorizarDadosDenunciado' style={{ display: '' }} className="has-error" ><br/>Autorizar se tiver certeza que seu nome seja apresentado ao denunciado.</span>
                                </div>
            }
            classificacoes = this.props.classificacoes.dado;
            txtMensagemDenuncia = 
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                        <div className="input-icon">
                            <label><b>Escreva seu relato:</b></label>
                            <div>
                                <textarea rows="6" cols="50" className="form-control" name="txtMensagem" id='txtMensagem' placeholder="" ref='txtMensagem'  />
                                <span ref='errMensagem' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                            </div>
                        </div>
                    </div>
                </div>
                

            formDenuncia = <DenunciaForm 
                            onChangetxtDenunciaDocumento={this.onChangetxtDenunciaDocumento} 
                            onChangetxtDenunciaEvidencia={this.onChangetxtDenunciaEvidencia} 
                            onChangetxtDenunciaLideranca={this.onChangetxtDenunciaLideranca} 
                            onChangetxtDenunciaMeioConhecimento={this.onChangetxtDenunciaMeioConhecimento} 
                            onChangetxtDenunciaQuandoOnde={this.onChangetxtDenunciaQuandoOnde} 
                            onChangetxtDenunciaTempo={this.onChangetxtDenunciaTempo} 
                            onChangetxtDenunciaTestemunha={this.onChangetxtDenunciaTestemunha}
                            onChangetxtDenunciaValor={this.onChangetxtDenunciaValor}
                            onChangetxtDenunciaAmeaca={this.onChangetxtDenunciaAmeaca}
                            getMeiosConhecimentoDenunciaSelecionada={this.getMeiosConhecimentoDenunciaSelecionada}
                        />;
            dropzoneDenuncia = (
                    <div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 drop">
                        <Dropzone style={{ position: "relative" }} accept={accept} maxSize={10000000} onDropRejected={this.onDropRejected.bind(this)} onDrop={this.onDrop.bind(this)}  onDragEnter={this.onDragEnter.bind(this)} onDragLeave={this.onDragLeave.bind(this)}>
                            {dropzoneActive && <div style={overlayStyle}>Solte para anexar</div>}
                            <div className='centerText'> <label ><b>Clique ou arraste nessa área para anexar:</b></label></div>
                            <div className='centerText'> <label ><b><i className="fa fa-paperclip fa-2x" aria-hidden="true"></i></b></label></div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 size">
                            </div>
                        </Dropzone>
                        <span ref='errorSizeDrop' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="form-group">
                            <div className="input-icon">
                            <span ref='errorExtensao' style={{ display: '' }} className="has-error">*Extensões permitidas: JPG, PNG, PDF, MP4, AVI e MP3. Tamanho máximo por arquivo permitido: 10mb.</span>
                            </div>
                        </div>
                    </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <div className="input-icon">
                                    <label style={{ display: 'none' }}><b>Arquivos anexados:</b></label>
                                    {lista}
                                </div>
                            </div>
                        </div>
                    </div>
            );
            
        }else{
            if (!$.isEmptyObject(this.props.grupoClassificacoes)) {
                //debugger
                classificacoes = [];
                for (let index = 0; index < this.props.grupoClassificacoes.dado.mClassificacoes.length; index++) {
                    if (this.props.grupoClassificacoes.dado.mClassificacoes[index].mVisivelExterno && this.props.grupoClassificacoes.dado.mClassificacoes[index].mIdClassificacao !==1){
                        classificacoes.push(this.props.grupoClassificacoes.dado.mClassificacoes[index]);
                    }
                }
            }
            txtMensagem = 
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                        <div className="input-icon">
                            <label><b>Escreva seu relato:</b></label>
                            <div>
                                <textarea rows="6" cols="50" className="form-control" name="txtMensagem" id='txtMensagem' placeholder="" ref='txtMensagem'  />
                                <span ref='errMensagem' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                            </div>
                        </div>
                    </div>
                </div>
            dropZoneGeral = (
                <div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 drop">
                        <Dropzone style={{ position: "relative" }} accept={accept} onDrop={this.onDrop.bind(this)} onDragEnter={this.onDragEnter.bind(this)} onDragLeave={this.onDragLeave.bind(this)}>
                            {dropzoneActive && <div style={overlayStyle}>Solte para anexar</div>}
                            <div className='centerText'> <label ><b>Clique ou arraste nessa área para anexar:</b></label></div>
                            <div className='centerText'> <label ><b><i className="fa fa-paperclip fa-2x" aria-hidden="true"></i></b></label></div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 size">
                            </div>
                        </Dropzone>
                        <span ref='errorSizeDrop' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="form-group">
                            <div className="input-icon">
                            <span ref='errorExtensao' style={{ display: '' }} className="has-error">*Extensões permitidas: JPG, PNG, PDF, MP4, AVI e MP3. Tamanho máximo permitido por arquivo: 10mb.</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="form-group">
                            <div className="input-icon">
                                <label style={{ display: 'none' }}><b>Arquivos anexados:</b></label>
                                {lista}
                            </div>
                        </div>
                    </div>
                </div>);

        }
        //debugger
        //se não existir grupo de tratamento, apresentar todas as classificações
        if (classificacoes.length===0){
            classificacoes = this.props.classificacoes.dado;
        }

        //SAC por UF: com a UF bloqueada só ficam o select de UF e a mensagem
        var sacIndisponivel = this.isSacIndisponivel(this.state.valueUFusuarioOrigem, this.props.uf);

        var ufOrigemHabilitada = true;
        if(this.isUPP() || (!$.isEmptyObject(this.props.params) && this.props.params.uf && this.props.params.grupo && this.props.params.grupo.toLowerCase()==='sac')){
            ufOrigemHabilitada = true;
        }
        else{
            ufOrigemHabilitada = false;
        }
        
        let naturezaVisivel = ''
        //debugger
        if(!$.isEmptyObject(this.props.params.natureza) && this.props.params.natureza === 'denuncia'){
            naturezaVisivel = 'none';
        }
        
    return (

        <div>
            <form method="post" id='login-form' >
            <div className="clearfix"></div>
                {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="contact-box-Blue widget">
                        <h3 className='titulo-Contact-box-Blue'>Informativo:</h3>
                        <i className="fa fa-bullhorn"></i>
                        <div className='text-aling-left'>
                        <p>Prezados Clientes,</p><br/>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A Ouvidoria Sebrae informa que o prazo de respostas das manifestações dos clientes do Sebrae MG, será mantido conforme normativos internos. Já as manifestações dos clientes dos demais estados, poderão sofrer suspensão do prazo de resposta, devido aos recessos de cada um, que ocorrerão entre os dias 17/12/2025 a 18/01/2026.</p><br/>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Agradecemos a compreensão, desejamos boas festas e um próspero Ano Novo!</p>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ouvidoria Sebrae</p>
                        </div>
                    </div>
                </div> */}
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                <div className="inputSelect">
                                    <div className="input-icon">
                                    <label><b>Deseja falar sobre o Sebrae de que estado?</b></label>
                                        <SelectUF  uf={this.props.uf}  filterme={this.onChangeUFOrigem} selecinarId={this.state.valueUFusuarioOrigem} disabled={ufOrigemHabilitada} multi={false}  />
                                            <span ref='errUFusuarioOrigem' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                                            {sacIndisponivel ? <span className="has-error">{SacUF.MENSAGEM_SAC_INDISPONIVEL}</span> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={sacIndisponivel ? { display: 'none' } : undefined}>
                        <div className="col-lg-5 col-md-5 col-sm-6 col-xs-12" style={{ display: naturezaVisivel }}>
                                <div className="form-group">
                                    <div className="input-icon">
                                        <label><b>Você quer fazer um(a):</b></label>
                                        <SelectClassificacoes multi={false} classificacoes={classificacoes} filterme={this.onChangeClassificar} selecinarId={this.state.classificacoesSelecinadas} disabled={this.isUPP()} />
                                        <span ref='errorClassificacao' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-5 col-sm-6 col-xs-12 textSideImg center">
                            <strong>Importante:</strong> Solicitamos a gentileza de fornecer detalhes relacionados ao motivo desse contato, com as seguintes informações, caso haja. <br/>Exemplo (Nome do curso/evento, Atendente, Local de atendimento etc.)
                            </div>
                            {txtMensagem}
                            {dropZoneGeral}
                        </div>
                        <row style={sacIndisponivel ? { display: 'none' } : undefined}>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bg" id="gbIdentificacao" style={{ display: '' }}>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 rowTituloImg"   style={{ display: !$.isEmptyObject(this.props.params.grupo) && this.props.params.grupo.toLowerCase() === 'sac' ? 'none' : 'visible' }}>
                                    <div className="form-group">
                                        <div className="input-icon">
                                            <label><b>Gostaria de se identificar?</b></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12" >
                                    <div className="well">
                                        <div className="scroll">
                                            <img id='imgIdentificado' className='imgIdentificado selected' onClick={this.ativarIdentificado} src={ConfigD.getServerBase() + '/img/cadastrarProtocolo/escudo-identificado_small.png'} />
                                            <img id='imgAnonimo' className='imgAnonimo' onClick={this.ativarAnonimo} src={ConfigD.getServerBase() + '/img/cadastrarProtocolo/escudo-anonimo_smal.png'} />
                                        </div>
                                    </div>  
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-3 col-xs-12 textSideImg" style={{ display: !$.isEmptyObject(this.props.params.grupo) && this.props.params.grupo.toLowerCase() === 'sac' ? 'none' : 'visible' }}> 
                            Para possibilitar o tratamento da sua manifestação precisamos que informe dados detalhados, como nome do curso/evento, nome do atendente e local de atendimento.
                                </div>
                            <div id='apresentarDadosPessoais' style={{ display: 'visible' }}>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <h3 className="title">Dados pessoais:
                                        </h3>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group inputSelect">
                                                <div className="input-icon">
                                                <SelectTipoPessoa  tiposPessoa={this.props.lsTipoPessoa}  onChangeTipo={this.onChangeTipoPessoa} selecinarId={this.state.valueTipoPessoa} disabled={false} multi={false}  />
                                                    <span ref='errorTipoPessoa' style={{ display: '' }} className="has-error">*Campo obrigatório</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    {/* <InputMask type='text' mask="999.999.999-99" placeholder='CPF' className="form-control" value={this.state.cpf} onChange={this.setCpf} onBlur={this.pesquisarCpfSAS} ref='txtCpf' name="txtCpf" id="txtCpf" /> */}
                                                    <InputMask type='text' mask="999.999.999-99" placeholder='CPF' className="form-control" value={this.state.cpf} onChange={this.setCpf} ref='txtCpf' name="txtCpf" id="txtCpf" />
                                                    <span ref='errCpf' id='errCpf' style={{ display: '' }} className="has-error">{this.state.errCpf}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    {/* <InputMask type='text' mask="99/99/9999" size="10" placeholder='Data de nascimento' className="form-control" value={this.state.dtNascimento} onChange={this.setDtNascimento} onBlur={this.pesquisarCpfSAS} ref='txtDtNascimento' name="txtDtNascimento" id="txtDtNascimento" /> */}
                                                    <InputMask type='text' mask="99/99/9999" size="10" placeholder='Data de nascimento' className="form-control" value={this.state.dtNascimento} onChange={this.setDtNascimento} ref='txtDtNascimento' name="txtDtNascimento" id="txtDtNascimento" />
                                                    <span ref='errDtNascimento' id='errDtNascimento' style={{ display: '' }} className="has-error">{this.state.errDtNascimento}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    <input type="text" className="form-control" placeholder="E-mail" ref='txtEmail' name="txtEmail" id='txtEmail' value={this.state.email} onChange={this.setEmail}  />
                                                    <span ref='errEmail' style={{ display: '' }} className="has-error">{this.state.errEmail}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    <input type="text" className="form-control" placeholder="Nome completo" name="txtNome" id='txtNome' ref='txtNome' value={this.state.nome} onChange={this.setNome}/>
                                                    <span ref='errNome' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    <InputMask type='text' mask="99.999-999" size="10" placeholder='Pesquisar Cep' className="form-control" value={this.state.cep} onChange={this.setCep} onBlur={this.consultaCep} ref='txtCep' name="txtCep" id="txtCep" />
                                                    <span ref='errCep' style={{ display: 'none' }} className="has-error" >{this.state.errCep}</span>                                                
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-10 col-md-8 col-sm-8 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    <input type="text" className="form-control" placeholder="Endereço" ref='txtEndereco' name="txtEndereco" id='txtEndereco' onChange={this.setEndereco} value={this.state.endEndereco} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    <input type="text" className="form-control" placeholder="Bairro" name="txtBairro" id='txtBairro' ref='txtBairro' onChange={this.setBairro} value={this.state.endBairro}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    <input type="text" className="form-control" placeholder="Cidade" ref='txtCidade' name="txtCidade" id='txtCidade' onChange={this.setCidade} value={this.state.endCidade} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                            <div className="inputSelect">
                                                <div className="input-icon">
                                                    <SelectUF  uf={this.props.uf}  filterme={this.onChangeUF} selecinarId={this.state.valueUFusuario} disabled={false} multi={false} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    <InputMask type='text' mask="(99) 99999-9999" size="14" placeholder='Celular' className="form-control" value={this.state.endCelular} onChange={this.setCelular} ref='txtCelular' name="txtCelular" id="txtCelular" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    <InputMask type='text' mask="(99) 9999-9999" size="14" placeholder='Telefone' className="form-control" value={this.state.endTelefone} onChange={this.setTelefene} ref='txtTelefone' name="txtTelefone" id="txtTelefone" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {txtMensagemDenuncia}
                                {dropzoneDenuncia}
                                {formDenuncia}
                                <Captcha idx={this.state.idx} refreshCaptcha={this.refreshCaptcha} setCaptchaValue={this.setCaptchaValue} setCaptchaUserValue={this.setCaptchaUserValue}  showError={this.state.showError} />
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <input type="checkbox" name="ckbAceitar" ref='ckbAceitar' id='ckbAceitar' className="input-icon"/> Autorizo o uso dos dados dessa manifestação para tratamento
                                    <span ref='errAceitoTermo' style={{ display: 'none' }} className="has-error" ><br/>Para prosseguir é necessário aceitar os termos de fornecimento de dados acima.</span>
                                  </div>
                                {autorizoDenuncia}
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <button type="submit" onClick={this.cadastrar} id='aceitoTermo'>Cadastrar</button>
                                </div>
                            </div>
                        </row>
                    </div>
                </div>
            </form>
        </div>
    );
  }
}

CadastarProtocoloForm.protoType = {
    //actionCliente: PropTypes.object.isRequired
    actionsUF: PropTypes.object.isRequired

}
CadastarProtocoloForm.contextTypes = {
    router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    //debugger;
    return {
        navegacao:state.navegacao,
        mensagem: state.mensagem,
        classificacoes: state.classificacoes,
        lsTipoPessoa: state.tipoPessoa.tiposVisiveis,
        uf: state.ufs,
        endereco: state.endereco,
        sas: state.sas,
        grupoClassificacoes: state.grupoTratamentoUFClassificacao,
        anexos: state.anexos

    };
}

function mapDispatchToProps(dispatch){
   return {
       actionsNavegacao: bindActionCreators(navegacaoActions, dispatch),
       actions: bindActionCreators(mensagemActions, dispatch),
       actionsClassificacao: bindActionCreators(classificacaoActions, dispatch),
       actionsTipoPessoa: bindActionCreators(tipoPessoaActions, dispatch),
       actionEndereco: bindActionCreators(enderecoActions, dispatch),
       actionsUF: bindActionCreators(ufActions, dispatch),
       actionsSAS: bindActionCreators(sasActions, dispatch), 
       actionsGrupoTratamentoUFClassificacao: bindActionCreators(grupoTratamentoUFClassificacaoActions, dispatch),
       actionsAnexos: bindActionCreators(anexosActions, dispatch),

    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(CadastarProtocoloForm);



/** WEBPACK FOOTER **
 ** ./src/components/CadastrarProtocoloForm.js
 **/